namespace Areas.ConstructionManagement.View {
    "use strict";

    var tabItems = Areas.createTabsWithSameActionAndDifferentAreas("Active",
        [
            "ChangeManagement/List",
            "ContractorPay/List",
            "MeetingMinutes/List",
            "PunchList/List",
            "Submittals/List",
            "Transmittals/List",
            "Warranty/List"
        ]);

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

}
